import React from "react";
import emailjs from "@emailjs/browser";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

// Yup validation schema
const ContactSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  interest: Yup.string().required("Required"),
  phone: Yup.string().required("Required"),
  message: Yup.string().required("Required"),
});

function ContactForm() {
  const sendEmail = (values, actions) => {
    const templateParams = {
      name: values.name,
      email: values.email,
      interest: values.interest,
      phone: values.phone,
      message: values.message,
    };

    emailjs
      .send(
        "service_3cpi8pa", // 🔁 Replace with your EmailJS service ID
        "template_ftiek9i", // 🔁 Replace with your template ID
        templateParams,
        "XcZAOLEuqAGCjPT-E", // 🔁 Replace with your EmailJS public key
      )
      .then(
        (response) => {
          console.log("Success:", response); // log response to confirm success
          alert("Message sent successfully!");
          actions.resetForm();
        },
        (error) => {
          console.error("Failed:", error); // log error to debug failure
          alert("Something went wrong. Please try again.");
        },
      )
      .finally(() => {
        actions.setSubmitting(false);
      });
  };

  return (
    <section>
      <div className="container contact-section py-5">
        <h1 className="getintouch">
          <span>Get in touch</span>
        </h1>
        <div className="row">
          <div className="col-md-6 mb-4 form-column pe-md-5">
            <h5 className="fw-bold">Send a Message</h5>
            <p className="form-subtext">
              Whether you’re building a brand, launching a product, or telling a
              story that matters — we’d love to hear from you.
            </p>

            <Formik
              initialValues={{
                name: "",
                email: "",
                interest: "",
                phone: "",
                message: "",
              }}
              validationSchema={ContactSchema}
              onSubmit={sendEmail}
            >
              {({ isSubmitting }) => (
                <Form>
                  <div className="row mb-4">
                    <div className="col">
                      <label className="form-label">Name</label>
                      <Field
                        name="name"
                        type="text"
                        className="custom-input"
                        placeholder="Your Name"
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-danger small"
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Email Address</label>
                      <Field
                        name="email"
                        type="email"
                        className="custom-input"
                        placeholder="you@example.com"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-danger small"
                      />
                    </div>
                  </div>

                  <div className="row mb-4">
                    <div className="col">
                      <label className="form-label">Interested in</label>
                      <Field
                        as="select"
                        name="interest"
                        className="custom-input"
                      >
                        <option value="">Choose...</option>
                        <option value="video">Video Production</option>
                        <option value="photo">Photography</option>
                        <option value="design">Design</option>
                      </Field>
                      <ErrorMessage
                        name="interest"
                        component="div"
                        className="text-danger small"
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Phone Number</label>
                      <Field
                        name="phone"
                        type="text"
                        className="custom-input"
                        placeholder="+41 76 699 01 64"
                      />
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="text-danger small"
                      />
                    </div>
                  </div>

                  <div className="mb-4">
                    <label className="form-label">Message</label>
                    <Field
                      as="textarea"
                      name="message"
                      className="custom-input"
                      rows="3"
                      placeholder="Write your message here..."
                    />
                    <ErrorMessage
                      name="message"
                      component="div"
                      className="text-danger small"
                    />
                  </div>

                  <div className="text-end">
                    <button
                      type="submit"
                      className="btn btn-primary px-4"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Sending..." : "Submit"}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>

          {/* Divider and contact info section (unchanged) */}
          <div className="col-md-1 d-none d-md-block">
            <div className="mx-auto vertical-divider h-100"></div>
          </div>

          <div className="col-md-5 contact-info ps-md-4">
            <div className="mb-4">
              <h6 className="fw-bold">Call Us</h6>
              <p className="info-subtext">
                Prefer to talk? So do we. Give us a call, let’s discuss your
                vision and how we can bring it to life.
              </p>
              <p>
                <i className="text-primary bi bi-telephone-fill me-2"></i>
                <a className="info-link">
                  <i className="icon ion-ios-telephone"></i>&nbsp; +41 76 699 01
                  64
                </a>
              </p>
            </div>

            <div className="mb-4">
              <h6 className="fw-bold">Visit Us</h6>
              <p className="info-subtext">
                Come by the studio, we’d love to host you.
              </p>
              <p>
                <i className="text-primary bi bi-geo-alt-fill me-2"></i>
                <a href="#" className="info-link">
                  <i className="icon ion-location"></i>&nbsp; Rr. Ukshin Hoti,
                  Prishtine 10000
                </a>
              </p>
            </div>

            <div className="mb-4">
              <h6 className="fw-bold">Email Us</h6>
              <p className="info-subtext">
                Got an idea, brief, or just a question?
                <br></br>Drop us a line — we usually reply within 24 hours.
              </p>
              <p>
                <i className="text-primary bi bi-envelope-fill me-2"></i>
                <a href="mailto:info@hobstudio.tv" className="info-link">
                  <i className="icon ion-android-mail"></i>&nbsp;
                  info@hobstudio.tv
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactForm;
